import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import * as Utilities from '../Utilities';

export default class SuggestedCommentItem extends Reflux.Component {
    getTopicLink = () => {
        return '/topic/' + this.props.comment.usertopic.id + '_' + this.props.comment.usertopic.title.replace(/_/g, '-').replace(/ /g, '-');
    }
    getUserLink = () => {
        return '/p/' + this.props.comment.createdBy.username;
    }
    getComment = () => {
        const limit = 80;
        let comment = this.props.comment.comment;
        if (this.props.comment.comment.length > limit) {
            comment = comment.slice(0, limit) + '...';
        }
        return comment;
    }
    render () {
        return (
          <div className='relative'>
            <Link className='user-box' to={this.getTopicLink()}>
              <div className='img-user-suggest'>
                <Link to={'/p/' + this.props.comment.createdBy.username} className='profileThumb'>
                  <object type='image/jpg' data={this.props.comment.createdBy.profile_image.sizeSmall ? this.props.comment.createdBy.profile_image.sizeSmall : '/images/icons/default.jpg'}>
                    <img
                      src='/images/icons/default.jpg'
                      className='responsive-img' />
                  </object>
                </Link>
              </div>
              <div className='txt-user-suggest'>
                <p className='titleTopComment'>
                  <Link to={this.getTopicLink()}>
                    {this.props.comment.usertopic.title}
                  </Link>
                </p>
                <span>{this.getComment()}</span>
                <div className='userCommentRelated'>
                  <Link className='userNameComment' to={this.getUserLink()}>
                    @{this.props.comment.createdBy.username}
                  </Link>
                  <span>{Utilities.getHumanTime(this.props.comment.createdAt)}</span>
                </div>
              </div>
            </Link>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/SuggestedCommentItem.js